<div class='px-2'>
  <div class='ContactActivityMobileRow mobile-row row px-3'>
    <div
      class='mobile-row-section col col-4'>{{ date | timezone: 'MM/DD/YYYY hh:mm a' : currentUser?.time_zone || null }}
    </div>
    <div class='mobile-row-section col col-4'>{{ type }}</div>
    <div class='mobile-row-section col col-4'>
      <app-message-detail
        [activityId]='item.activity_id'
        [contactInfo]='contactInfo'
        [messageContent]='content'
        [messageDetail]='message'
        [messageType]='type'
      ></app-message-detail>
    </div>
  </div>
</div>